<template>
  <div class="dc-menu__item d-flex align-items-center pointer"
       @click="emit('click')">
    <div class="dc-menu__icon">
      <MenuCancel class="svg-red" v-if="type === 'CANCEL'" />
      <MenuDelete v-if="type === 'DELETE'" />
      <MenuConfirm v-if="type === 'CONFIRM'" />
      <MenuCheck v-if="type === 'CAME'" />
      <MenuEdit v-if="type === 'EDIT'" class="svg-stroke-light" />
      <MenuView v-if="type === 'VIEW'" />
      <MenuEmail v-if="type === 'EMAIL'" />
      <MenuPay v-if="type === 'PAY'" />
      <MenuPatient v-if="type === 'PATIENT'" />
      <MenuPhone v-if="type === 'PHONE'" />
      <MenuSMS class="svg-light svg-size-md" v-if="type === 'SMS'" />
      <MenuWhatsapp class="svg-light svg-size-md" v-if="type === 'WHATSAPP'" />
      <MenuTelegram v-if="type === 'TELEGRAM'" />
      <MenuMax class="svg-light svg-size-md" v-if="type === 'MAX'" />
      <MoveSvg class="svg-stroke-light" v-if="type === 'MOVE'" />
      <CopySvg v-if="type === 'COPY'" />
      <MenuNotComeSvg v-if="type === 'DID_NOT_COME'" class="svg-red"/>
      <slot/>
    </div>
    <div class="dc-menu__title"
         :class="{'text-danger': ['DELETE','CANCEL','DID_NOT_COME'].includes(type) }">
      {{ title }}
    </div>
    <RightSvg v-if="showArrow" class="dc-menu__arrow-right" />

  </div>
</template>

<script setup>
import MenuDelete from '@/assets/svg-vue/calendar/menu_cancel.svg'
import MenuCancel from '@/assets/svg-vue/calendar/menu_delete.svg'
import MenuConfirm from '@/assets/svg-vue/calendar/menu_confirm.svg'
import MenuEdit from '@/assets/svg-vue/calendar/menu_edit.svg'
import MenuView from '@/assets/svg-vue/calendar/menu_view.svg'
import MenuEmail from '@/assets/svg-vue/calendar/menu_email.svg'
import MenuPay from '@/assets/svg-vue/calendar/menu_pay.svg'
import MenuPatient from '@/assets/svg-vue/calendar/menu_patient.svg'
import MenuPhone from '@/assets/svg-vue/calendar/menu_phone.svg'
// import MenuSMS from '@/assets/svg-vue/calendar/menu_sms.svg'
import MenuSMS from '@/assets/svg-vue/crm/sms.svg'
import MenuWhatsapp from '@/assets/svg-vue/crm/whatsapp.svg'
import MenuTelegram from '@/assets/svg-vue/calendar/menu_sms.svg'
import MenuMax from '@/assets/svg-vue/crm/max.svg'
import MenuCheck from '@/assets/svg-vue/calendar/menu_check.svg'
import MoveSvg from '@/assets/svg-vue/general/move.svg'
import CopySvg from '@/assets/svg-vue/patients/copy3.svg'
import RightSvg from '@/assets/svg-vue/general/arrow_down.svg'
import MenuNotComeSvg from '@/assets/svg-vue/calendar/menu_not_come.svg'

const emit = defineEmits(['click'])

defineProps({
  type: String,
  title: String,
  isCancel: {
    type: Boolean,
    default: false
  },
  showArrow: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped>
.dc-menu__item {
  padding: 6px 45px 6px 15px;
  background-color: white;
  color: #5D6D7C;
  &.symmetric {
    padding-right: 15px;
  }
}
.dc-menu__item:hover {
  background-color: #F3F3F3;
}
.dc-menu__icon {
  display: flex;
  width: 28px;
  flex-shrink: 0;
}
</style>
